import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const CarouselSection = memo(({ theme, sectionId }) => {
  const CarouselLayout = dynamic(() => import(/* webpackChunkName: 'CarouselSectionLayout' */ `../../../../../containers/home-page/views/sections/carousel/layouts/${theme.layout}`))

  return (
    <CarouselLayout
      sectionId={sectionId}
    />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

CarouselSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default CarouselSection
